import { render, staticRenderFns } from "./candidate_civil_state_result.vue?vue&type=template&id=5b401f56&scoped=true&"
import script from "./candidate_civil_state_result.vue?vue&type=script&lang=js&"
export * from "./candidate_civil_state_result.vue?vue&type=script&lang=js&"
import style0 from "./candidate_civil_state_result.vue?vue&type=style&index=0&id=5b401f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b401f56",
  null
  
)

export default component.exports